import { useToast } from "../../../../components/common/toasts/ToastContext";
import React, { useState } from "react";
import GusSearch from "../../../../components/common/GusSearch";
import { premiumError } from "../../../../services/Premium";
import { Field } from "../Fields";

/** Dane firmy i eksportera uzupełniane ręcznie lub z wyniku wyszukiwania GUS. */
export default function CompanyProfileFields({
  name,
  config,
  onNameChange,
  onConfigChange,
}) {
  const [gusVisible, setGusVisible] = useState(false);
  const { notify } = useToast();
  const acceptCompany = (result) => {
    if (!result.Name) {
      notify(
        "GUS nie zwrócił nazwy firmy. Sprawdź NIP lub uzupełnij dane ręcznie.",
        "warning",
      );
      return;
    }
    const building = [result.Building, result.Appartment]
      .filter(Boolean)
      .join("/");
    const address = [
      [result.Street, building].filter(Boolean).join(" "),
      [result.PostCode, result.City].filter(Boolean).join(" "),
    ].filter(Boolean);
    onNameChange(result.Name);
    onConfigChange({
      city: result.City || "",
      exporter: [result.Name, ...address, "POLAND"].join("\n"),
    });
    notify(
      `Pobrano dane dla NIP ${result.NIP}. Sprawdź nazwę, adres i treść pola eksportera przed zapisaniem.`,
      "info",
    );
  };
  return (
    <section className="card premium-panel" aria-label="Dane firmy">
      <div className="premium-toolbar">
        <h2>Dane firmy</h2>
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={() => setGusVisible(true)}
        >
          Pobierz dane firmy po NIP
        </button>
      </div>
      <GusSearch
        visible={gusVisible}
        handleCancel={() => setGusVisible(false)}
        handleSearch={acceptCompany}
        onError={(error) => notify(premiumError(error), "danger")}
      />
      <div className="premium-grid">
        <Field
          label="Nazwa firmy w panelu"
          required
          maxLength={200}
          value={name}
          onChange={(event) => onNameChange(event.target.value)}
        />
        <Field
          label="Miejscowość eksportera"
          required
          value={config.city}
          onChange={(event) => onConfigChange({ city: event.target.value })}
        />
      </div>
      <Field
        label="Eksporter — pełna treść pola 1 świadectwa"
        multiline
        required
        value={config.exporter}
        onChange={(event) => onConfigChange({ exporter: event.target.value })}
      />
    </section>
  );
}
